import { setRuntimePublicPath } from './runtime-public-path'

setRuntimePublicPath('/account/build/', '/account/build/')
